<template>
  <div>
    <modal @closed="closeModal" class="modal" name="createHomeModal" :width="770" height="auto" :adaptive="true" :scrollable="true" style="z-index:1000">
      <button @click="closeModal" class="absolute right-0 m-3">
        <img src="@/assets/img/close.svg" alt="Close">
      </button>
      <div class="mt-10 mx-auto w-max">
        <h2>Locatie toevoegen</h2>
      </div>

      <formulate-form ref="locationForm" name="locationForm" v-model="formValues" @submit="createHome()" class="mb-6">
        <div class="container">
          <formulate-input validation="required" error-behavior="submit" type="text" name="name" label="Name"></formulate-input>
          <formulate-input validation="required" error-behavior="submit" type="text" name="address" label="Address + housenumber"></formulate-input>
          <div class="flex gap-4">
            <formulate-input validation="required" class="md" error-behavior="submit" type="text" name="postcode" label="Postal Code"></formulate-input>
            <formulate-input class="w-full" validation="required" error-behavior="submit" type="text" name="city" label="City"></formulate-input>
          </div>
          <formulate-input validation="required" error-behavior="submit" type="text" name="country" label="Country"></formulate-input>
          <formulate-input validation="required" error-behavior="submit" type="select" name="type" label="Customer Type" :options="[{ value: 'individual', label: 'Individual' }, { value: 'professional', label: 'Professional' }]"></formulate-input>
          <formulate-input type="submit" :label="$t('Bevestigen')" class="bg-wilmsBlue w-max text-white rounded-sm p-2"/>
        </div>
      </formulate-form>
    </modal>
  </div>
</template>

<script>
export default {
  props: ['open'],
  data () {
    return {
      formValues: {}
    }
  },
  methods: {
    closeModal () {
      this.$modal.hide('createHomeModal')
      this.$emit('close')
    },
    openModal () {
      this.$modal.show('createHomeModal')
    },
    async createHome () {
      await this.$store.dispatch('HomesModule/createHome', {
        home: this.formValues
      })
      this.$emit('close')
    }
  },
  watch: {
    open () {
      if (this.open) {
        this.openModal()
      } else {
        this.closeModal()
      }
    }
  }
}
</script>
